import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import principle04 from "./layouts/principle-04/principle";
import principle05 from "./layouts/principle-05/principle";
import principle06 from "./layouts/principle-06/principle";

const lesson: Lesson = {
  id: "3fc25fad-e319-471c-a918-bd6c3e523187",
  publicId: "31",
  name: "Sound Quality Analysis: Binaural Recording - Processing - Jury Test - Analysis and Metric Generation",
  showHeaderNavigation: true,
  body: [principle01, principle02, principle03, principle04, principle05, principle06],
};

export default lesson;
